import { render, staticRenderFns } from "./SMenuItem.vue?vue&type=template&id=20c20b42&scoped=true&"
import script from "./SMenuItem.vue?vue&type=script&lang=ts&"
export * from "./SMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./SMenuItem.vue?vue&type=style&index=0&id=20c20b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c20b42",
  null
  
)

export default component.exports